<div class="modal-header modal-head">
    <h4 class="modal-titles" [hidden]="actionTemplate.title==''?true:false">
        {{actionTemplate.title}}
    </h4>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col">
            <div class="m-3 text-center">
                <p>{{actionTemplate.body}}</p>
            </div>
        </div>
    </div>
    <!-- Modal footer -->
    <div class="modal-foot">
        <div class="row my-3 text-center">
            <button type="button" class="btn btn-fw text me-3"
                [hidden]="!actionTemplate.buttonConfirmVisible"
                (click)="confirm()">{{actionTemplate.textButtonConfirm}}</button>
            <button type="button" class="btn btn-outline-warning btn-outline-fw text"
                [hidden]="!actionTemplate.buttonCancelVisible"
                (click)="cancel()">{{actionTemplate.textButtonCancel}}</button>
        </div>
    </div>
</div>


    